import { GriddedItem, GridLayout, GridState } from "./grid";
import { pxFromVw, cloneWidthHeight } from "./helpers";

export default function slideshowGridder(items: HTMLElement[], state: GridState, previousState: GridState): GridLayout {

  let itemList: GriddedItem[] = [];

  let startNo = state.startNo ?? 0;
  let previousStartNo = previousState.startNo ?? 0;
  let slideMode = state.gridSlideMode ?? 'single';
  let ratioMode = state.gridSlideWidthHeightRatioMode ?? 'custom';
  let ratio = state.gridSlideWidthHeightRatio ?? 1.8;
  let containerWidth = state.containerWidth;

  let inline = slideMode === 'inline';
  let slideForward = previousStartNo < startNo;
  let marginX = pxFromVw(state.gridSpacingX ?? 0);

  if (inline) {
    ratioMode = 'container';
  }

  // Get width/height ratio for slideshow
  if (ratioMode === 'browser') {
    let clientWidth = document.documentElement.clientWidth ?? document.body.clientWidth;
    let clientHeight = document.documentElement.clientHeight ?? document.body.clientHeight;
    let availableWidth = clientWidth - state.containerMarginLeft - state.containerMarginRight;
    let availableHeight = clientHeight - state.containerMarginTop - state.containerMarginBottom;
    ratio = availableWidth / availableHeight;
  }
  else if (ratioMode === 'container') {
    ratio = state.containerWidth / state.containerHeight;
  }
  else if (ratioMode === 'auto') {
    let item = items[startNo];
    let itemDimensions = cloneWidthHeight(item);
    ratio = itemDimensions.width / itemDimensions.height;
  }

  let paneWidth = 0;
  let paneHeight = state.containerWidth / ratio;
  let startOffsetX: number;

  // For each item, count the numer of skips needed to make the entire item visible
  let skipCount = 0;

  for (let i=0; i<items.length; i++) {
    let item = items[i];
    let itemDimensions = cloneWidthHeight(item);
    let itemWidthHeightRatio = itemDimensions.width / itemDimensions.height;
    let itemHeight = paneHeight;
    let itemWidth: number;
    if (inline) {
      itemWidth = paneHeight * itemWidthHeightRatio;
    } else {
      itemWidth = state.containerWidth;
    }

    // Inline galleries should align LAST image on slide forward, FIRST on default
    if (slideForward && inline) {
      // Find first image that's not fully shown
      let itemRight = paneWidth + itemWidth;
      if (i < items.length-1) {
        itemRight += marginX;
      }
      if (itemRight >= containerWidth && skipCount++ < startNo) {
        startOffsetX = itemRight - containerWidth;
      }
    } else {
      if (i === startNo) {
        startOffsetX = paneWidth;
      }
    }

    itemList.push({
      DOM: item,
      css: {
        top: 0,
        left: paneWidth,
        width: itemWidth,
        height: itemHeight
      }
    });

    paneWidth += itemWidth;
    // Don't add right margin to last item
    if (inline && i < items.length-1) {
      paneWidth += marginX;
    }
  }

  return {
    itemList: itemList,
    height: (ratioMode === 'container') ? '' : paneHeight,
    width: paneWidth,
    translateX: - Math.max(0, Math.min(startOffsetX,paneWidth-state.containerWidth))
  };

};
